import logo from "assets/img/logo.jpg";
import coopanest from "assets/img/coopanest.png";
import itajuba from "assets/img/itajuba.jpeg";

export default function getLogo(logoName) {
  let logoToUse = logo;
  if (logoName === "coopanest") {
    logoToUse = coopanest;
  } 
  if (logoName === "itajuba") {
    logoToUse = itajuba
  }

  return logoToUse;
}